module.exports = __webpack_public_path__ + "99a806e47775afd223964228b139aef2.svg";